export default __webpack_public_path__ + "static/media/empty-filtered-teams.1bd76f5b.svg";